import { Stack, Typography } from "@mui/material"
import { OutlinedInput, } from "@mui/material";
import { BooleanEntryValue } from "./BooleanEntryValue";

export default function EntryValue({...params}){
    let pageMode = params.pageMode

    let stateObject = params.stateObject
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper

    let title = params.title
    let toggleFocus = params.toggleFocus

  
    let placeholder = ''
    if (stateObject[title].oldValue === "") placeholder = "—"
    else {
        if (stateObject[title].currentValue === "" && stateObject[title].currentInput === "") placeholder = stateObject[title].oldValue
        else if (stateObject[title].currentValue !== "" && stateObject[title].currentInput === "") placeholder = stateObject[title].currentValue
        else if (stateObject[title].currentInput !== "") placeholder = stateObject[title].currentInput
    }


    const inputChanged = (event) => {
        event.preventDefault()
        setStateObjectEntryFieldHelper(title, 'currentInput', event.target.value)
        setStateObjectEntryFieldHelper(title, 'updatedState', true)
    }

    const handleBlur = (event) => {
        event.preventDefault()
        toggleFocus(event)
    }


    return (
        <>
        
            {/*special case for boolean red x and green checkmark */}
            {(typeof stateObject[title].oldValue === 'boolean') ? (
                <BooleanEntryValue pageMode={pageMode} stateObject={stateObject} setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper} 
                                    title={title} />
            )
            
            /* normal read mode  (top picture)*/
            :(pageMode === 'read') ? (
                <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
            )

            /* edit mode, unedited, locked  (Row 1)*/
            :(pageMode === 'edit' && !stateObject[title].updatedState && stateObject[title].lockState) ? (
                <Stack direction={'column'}>
                    <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                </Stack>
            )

            /* edit mode, updated, locked  (Row 11) (green lock case)*/
            :(pageMode === 'edit' && stateObject[title].updatedState && stateObject[title].lockState) ? (
                <Stack direction={'column'}>
                    <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                </Stack>
            )


            /* edit mode, updated or not updated, unlocked, unfocused  (Row 3)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && !stateObject[title].focusState) ? (
                <Stack direction={'column'}>
                    <Typography onClick={toggleFocus} alignSelf={'center'} fontSize={'18px'} fontWeight={400}>{String(placeholder)}</Typography>
                </Stack>
            )


            /* edit mode, unlocked, not updated, focused  (Row 6)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && !stateObject[title].updatedState  && stateObject[title].focusState) ? (
                <OutlinedInput
                    placeholder={placeholder}
                    onChange={inputChanged}
                    disabled={stateObject[title].lockState}
                    autoFocus
                    onBlur={(event) => handleBlur(event)}
                />
            )


            /* edit mode, unlocked, updated, focused  (Row 7)*/
            :(pageMode === 'edit' && !stateObject[title].lockState && stateObject[title].updatedState && stateObject[title].focusState) && (
                <OutlinedInput
                    defaultValue={String(stateObject[title].currentInput)}
                    onChange={inputChanged}
                    disabled={stateObject[title].lockState}
                    autoFocus
                    onBlur={(event) => handleBlur(event)}
                />
            )}
        </>
    )
}
